// src/pages/Admin/Users/components/UsersCards.jsx
import React, { useState } from "react";
import ButtonEdit from "../../../../components/Button/ButtonEdit";
import ButtonDelete from "../../../../components/Button/ButtonDelete";
import { InlineRoleSelect } from "./InlineRoleSelect";
import { RoleBadge } from "./RoleBadge";

export function UsersCards({
  data,
  onEdit,
  onDelete,
  onInlineRole,
  roleById,
  fmtDate,
  roles,
}) {
  return (
    <div className="p-3 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
      {data.map((u) => (
        <UserCardItem
          key={u.id}
          u={u}
          onEdit={onEdit}
          onDelete={onDelete}
          onInlineRole={onInlineRole}
          roleById={roleById}
          fmtDate={fmtDate}
          roles={roles}
        />
      ))}
    </div>
  );
}

function UserCardItem({
  u,
  onEdit,
  onDelete,
  onInlineRole,
  roleById,
  fmtDate,
  roles,
}) {
  const [open, setOpen] = useState(false);
  const role = roleById.get(u.role_id);
  const detailsId = `user-details-${u.id}`;

  return (
    <div className="rounded-2xl p-4 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800">
      <div className="flex items-start gap-3">
        <div className="flex-1 min-w-0">
          <div className="font-semibold truncate">
            {u.nom} {u.prenom}
          </div>
          <div className="text-sm text-slate-500 truncate">
            {u.email || "—"}
          </div>
        </div>
        <div className="flex items-center gap-2">
          <ButtonEdit onClick={() => onEdit(u)} />
          <button
            type="button"
            onClick={() => setOpen((o) => !o)}
            aria-expanded={open}
            aria-controls={detailsId}
            className="px-2.5 py-1.5 text-xs rounded-lg border border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-800"
          >
            {open ? "▲" : "▼"}
          </button>
        </div>
      </div>

      <div
        id={detailsId}
        className={`transition-all duration-200 ease-out ${
          open ? "mt-3 max-h-[1000px]" : "max-h-0"
        } overflow-hidden`}
      >
        <div className="rounded-xl border border-slate-200 dark:border-slate-800 p-3 bg-slate-50 dark:bg-slate-800/60">
          <div className="mb-2 flex items-center gap-2">
            <RoleBadge tone={role?.badge}>
              {role?.label || "Non affecté"}
            </RoleBadge>
            <InlineRoleSelect
              value={u.role_id}
              options={roles}
              onChange={(v) => onInlineRole(u, v)}
              size="sm"
            />
          </div>

          <div className="grid grid-cols-1 gap-2 text-sm">
            <Info label="Email" value={u.email || "—"} />
            <Info label="Créé le" value={fmtDate(u.createdOn)} />
          </div>

          <div className="mt-3 flex gap-2">
            <ButtonDelete onClick={() => onDelete(u.id)} />
          </div>
        </div>
      </div>
    </div>
  );
}

function Info({ label, value, className = "" }) {
  return (
    <div
      className={`rounded-lg bg-white dark:bg-slate-900/60 p-2 border border-slate-200 dark:border-slate-800 ${className}`}
    >
      <div className="text-xs text-slate-500">{label}</div>
      <div className="font-medium">{value}</div>
    </div>
  );
}
